import { render, staticRenderFns } from "./ListaAutosInfracaoPorPlaca.vue?vue&type=template&id=37435519&scoped=true"
import script from "./ListaAutosInfracaoPorPlaca.vue?vue&type=script&lang=js"
export * from "./ListaAutosInfracaoPorPlaca.vue?vue&type=script&lang=js"
import style0 from "./ListaAutosInfracaoPorPlaca.vue?vue&type=style&index=0&id=37435519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37435519",
  null
  
)

export default component.exports